import { supabase } from '../../supabaseClient';
import { absenceBrickId } from '../../utils/absences';

/* Accès aux données « timesheets ». Chaque fonction renvoie la requête Supabase telle quelle
   (à attendre par l'appelant) : aucune logique métier ici. */

export function upsertAbsenceTimesheets(rows) {
  return supabase.from('timesheets').upsert(rows, { onConflict: 'user_id,date,brique_id,source' });
}

export function deleteUserTimesheets(absence, dates) {
  return supabase
    .from('timesheets')
    .delete()
    .eq('user_id', absence.user_id)
    .eq('brique_id', absenceBrickId(absence.type))
    .in('date', dates);
}

// Remplace la saisie d'une journée (hors absences) en une transaction ; la base refuse une journée
// portée au-delà de 7h (cf. supabase/006_timesheets_plafond_7h.sql).
export function saveTimesheetDay(date, rows) {
  return supabase.rpc('save_timesheet_day', {
    p_date: date,
    p_rows: rows.map(({ dev_id, brique_id, heures, note }) => ({
      dev_id,
      brique_id,
      heures,
      note,
    })),
  });
}
